<script setup lang="ts">
import { nextTick, ref } from 'vue';
import {
  Button, Modal, Spin, notification,
} from 'ant-design-vue';

import FileAiReviewCreateForm, { type FormValues } from './form.vue';

import { useFileAiReviewCreateMutation } from '@/graphql/generated/graphql';
import type { FileFragmentFragment } from '@/graphql/generated/graphql';

const props = defineProps<{ file: FileFragmentFragment, onRefetch: () => void }>();

const { fetching, executeMutation, error } = useFileAiReviewCreateMutation();

const modalOpen = ref(false);
const openModal = async () => {
  modalOpen.value = true;
  await nextTick();
};
const closeModal = () => {
  if (!fetching.value) {
    modalOpen.value = false;
  }
};

const runCreate = async (payload: FormValues) => {
  const result = await executeMutation({
    input: {
      fileId: props.file.id,
      fileContentId: payload.fileContent.id,
      modelDriver: payload.modelDriver,
      promptId: payload.fileAiPrompt.id,
    },
  });
  if (result.data?.fileAiReviewCreate) {
    notification.success({
      message: 'AI review run finished',
      description: `Row id ${result.data.fileAiReviewCreate.id}`,
    });
    props.onRefetch();
    modalOpen.value = false;
  }
};
</script>

<template>
  <Button type="primary" @click="openModal">
    Run AI review
  </Button>
  <Modal
    title="Run file AI review"
    :open="modalOpen"
    :footer="null"
    width="640px"
    @cancel="closeModal"
  >
    <Spin :spinning="fetching">
      <FileAiReviewCreateForm
        ref="createFormRef"
        :file="file"
        :fetching="fetching"
        :error="error"
        @close="closeModal"
        @submit="runCreate"
      />
    </Spin>
  </Modal>
</template>
